/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsReferences,
    MelcoModelsReferencesFromJSON,
    MelcoModelsReferencesFromJSONTyped,
    MelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsAlphabetCollectionReferences
 */
export interface MelcoModelsAlphabetCollectionReferences {
    /**
     * 
     * @type {Array<MelcoModelsReferences>}
     * @memberof MelcoModelsAlphabetCollectionReferences
     */
    mapping_list?: Array<MelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<MelcoModelsReferences>}
     * @memberof MelcoModelsAlphabetCollectionReferences
     */
    global_mapping_list?: Array<MelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<MelcoModelsReferences>}
     * @memberof MelcoModelsAlphabetCollectionReferences
     */
    format_list?: Array<MelcoModelsReferences> | null;
}

export function MelcoModelsAlphabetCollectionReferencesFromJSON(json: any): MelcoModelsAlphabetCollectionReferences {
    return MelcoModelsAlphabetCollectionReferencesFromJSONTyped(json, false);
}

export function MelcoModelsAlphabetCollectionReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsAlphabetCollectionReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mapping_list': !exists(json, 'mapping_list') ? undefined : (json['mapping_list'] === null ? null : (json['mapping_list'] as Array<any>).map(MelcoModelsReferencesFromJSON)),
        'global_mapping_list': !exists(json, 'global_mapping_list') ? undefined : (json['global_mapping_list'] === null ? null : (json['global_mapping_list'] as Array<any>).map(MelcoModelsReferencesFromJSON)),
        'format_list': !exists(json, 'format_list') ? undefined : (json['format_list'] === null ? null : (json['format_list'] as Array<any>).map(MelcoModelsReferencesFromJSON)),
    };
}

export function MelcoModelsAlphabetCollectionReferencesToJSON(value?: MelcoModelsAlphabetCollectionReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mapping_list': value.mapping_list === undefined ? undefined : (value.mapping_list === null ? null : (value.mapping_list as Array<any>).map(MelcoModelsReferencesToJSON)),
        'global_mapping_list': value.global_mapping_list === undefined ? undefined : (value.global_mapping_list === null ? null : (value.global_mapping_list as Array<any>).map(MelcoModelsReferencesToJSON)),
        'format_list': value.format_list === undefined ? undefined : (value.format_list === null ? null : (value.format_list as Array<any>).map(MelcoModelsReferencesToJSON)),
    };
}


